<div class="animate__animated animate__fadeIn">
  <div *ngIf="showLabel" class="m-b-8">
    <div  class="amount-label animate__animated animate__fadeIn">
      {{label}}
    </div>
  </div>
  <div class="custom-amount-container {{disableInput?'input-disabled':''}}">
    <nz-input-group class="custom-amount {{inputClass}}" [nzAddOnBefore]="addOnBeforeTemplate">
      <input [ngClass]="{'mobile-height': inputHeightForMobile}" [(ngModel)]="inputValue" [ngStyle]="{'font-size': (initialAmount?.toString().length >= 9  ||
      inputValue?.toString().length >= 9 ) ? fontSize()+'px' : '34px'}"
             [disabled]="disableInput"
             (focusin)="setInputClass(1)"
             (focusout)="setInputClass(0)"
             (keyup)="formatNumber($event.target)"
             type="text" name="currency-field"
             id="currency-field"
             pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
             data-type="currency"
             placeholder="">
    </nz-input-group>
    <ng-template #addOnBeforeTemplate>
      <div style="position: relative;top:3px;left:6px">
        <app-grey-icon greyIcon="grey-naira">
        </app-grey-icon>
      </div>
    </ng-template>
  </div>
  <div *ngIf="showAmountRange" class="m-t-8">
    <div class="amount-label animate__animated animate__fadeIn">
      <span class="m-r-4" *ngIf="minAmount">Min: ₦ {{minAmount|currency}}</span>  <span style="position: relative;left:8px" *ngIf="maxAmount">--- Max: ₦ {{maxAmount|currency}}</span>
    </div>
  </div>
  <div *ngIf="showError && !showAmountRange" class="m-t-8">
    <div *ngIf="error"
     class="amount-error-message animate__animated animate__fadeIn">
      {{errorMessage}}
    </div>
  </div>
</div>

